import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiQuestionnaireLayout, UiText} from '~/components/elements';
import SpecialText from '~/components/shared/SpecialText';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire6AScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.BMI_CALCULATOR]?.data,
  );

  const collectedData = mdq.collectedData;

  useEffect(() => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    if (medicalUUID) {
      dispatch(
        submitOrLogMdq({
          data: {
            uid: medicalUUID,
            methodKey: methodKey.toLowerCase(),
            status: 'draft',
            data: {
              ...collectedData,
              [WEIGHT_LOSS_KEYS.BMI_UNDERWEIGHT]: answerData,
            },
          },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions} pageTitle={questionnaire?.title}>
      <Col alignItems="center" textAlign="center" mt={28} px={2}>
        <UiText fontSize="2xl" fontWeight="bold" mb={6}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText maxW={80} fontSize="sm" mb={5}>
          {questionnaire?.questions?.sub}
        </UiText>
        <Row style={{alignItems: 'center'}} mb={4}>
          <UiText fontSize="xl" color="black">
            Your BMI is
          </UiText>
          <UiText fontWeight="bold" fontSize="xl" ml={2}>
            {currentAnswer?.bmi}
          </UiText>
        </Row>
        <Col>
          {questionnaire?.descriptions?.default?.map(desc => (
            <SpecialText text={desc} key={desc} />
          ))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire6AScreen;
